/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"

import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import AGCRoziKasimaService from "../../../service/billing/AGCRoziKasima/aGCRoziKasimaService"
import {
  TAGCRoziKasimaKosokuryoHokokuListGetReq,
  TAGCRoziKasimaKosokuryoHokokuListGetRes,
} from "../../../service/billing/AGCRoziKasima/TAGCRoziKasima"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import { excelFormat, pdfFormat } from "../../../ts/util/haisyaUtil"
import DateInput from "../../../components/InputWrapper/DateInput"

/**
 * AGCロジ鹿島 高速料報告
 * 2022/10/01 AGCロジ鹿島 ⇒ AGL鹿島ガラスに分社化したため、表面文字列のみ変更
 * @returns
 */
const AGCRoziKasimaKosokuryoHokokuRegister = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "AGLKasimaKosokuryoHokoku_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TAGCRoziKasimaKosokuryoHokokuListGetRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        padding車番: (data: TAGCRoziKasimaKosokuryoHokokuListGetRes) =>
          data.請求車番 != null && data.請求車番 !== ""
            ? data.請求車番?.padStart(4, "0")
            : "9999",
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (
    searchCondition?: TAGCRoziKasimaKosokuryoHokokuListGetReq
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TAGCRoziKasimaKosokuryoHokokuListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new AGCRoziKasimaService().getList(
        currentSearchCondition
      )
      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
      // setAccordionController(false)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TAGCRoziKasimaKosokuryoHokokuListGetReq = queryString.parse(
      location.search
    )
    set年月from(query.年月from)
    set年月to(query.年月to)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TAGCRoziKasimaKosokuryoHokokuListGetReq => {
    const 月初 = dayjs(eigyobi).startOf("month").format("YYYY/MM/DD")
    const 月末 = dayjs(月初).endOf("month").format("YYYY/MM/DD")
    return {
      年月from: 年月from ?? 月初,
      年月to: 年月to ?? 月末,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TAGCRoziKasimaKosokuryoHokokuListGetReq
  ) => {
    const disp年月from = dayjs(searchCondition.年月from).format("YYYY/MM/DD")
    const disp年月to = dayjs(searchCondition.年月to).format("YYYY/MM/DD")

    return {
      年月from: wjCore.isNullOrWhiteSpace(disp年月from ?? "")
        ? ""
        : disp年月from,
      年月to: wjCore.isNullOrWhiteSpace(disp年月to ?? "") ? "" : disp年月to,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    const 月初 = dayjs(eigyobi).startOf("month").format("YYYY/MM/DD")
    const 月末 = dayjs(月初).endOf("month").format("YYYY/MM/DD")
    set年月from(月初)
    set年月to(月末)
    ref明細フォーマットフラグ.current = false
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  // state
  const [年月from, set年月from] = useState<string | null>()
  const [年月to, set年月to] = useState<string | null>()

  //#endregion

  //#region [effect]

  useEffect(() => {
    // 初期表示生成のため画面ロック
    const 月初 = new Date(
      dayjs(eigyobi).year(),
      dayjs(eigyobi).month(),
      1
    ).toLocaleDateString()
    //dayjs(new Date()).year() + "/" + dayjs(new Date()).month() + "01"
    const 月末 = dayjs(月初).add(1, "month").add(-1, "day").format("YYYY/MM/DD")
    dispatch(画面ロック開始())
    set年月from(月初)
    set年月to(月末)
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">AGL鹿島ガラス 高速料報告</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <ul className="list-cmn d-flex">
                          <li className="list-cmn list-padding w-15rem">
                            <DateInput
                              id="検索日from"
                              placeholder="卸日From"
                              isRequired={true}
                              has1DayButton={true}
                              value={年月from}
                              setValue={(v) => {
                                set年月from(v)
                              }}></DateInput>
                          </li>
                          <li className="list-cmn list-padding w-15rem">
                            <DateInput
                              id="検索日To"
                              placeholder="卸日To"
                              value={年月to}
                              isRequired={true}
                              has1DayButton={true}
                              setValue={(v) => {
                                set年月to(v)
                              }}></DateInput>
                          </li>
                        </ul>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                pdfFormatItem={pdfFormat}
                excelFormatItem={excelFormat}
                isShowGridRowPickupButton={true}
                gridProperties={{
                  isReadOnly: true,
                }}>
                <wjrGrid.FlexGridColumn
                  cssClass="read-only-cell"
                  binding="積日"
                  width={100}
                  header="積日"
                  format={"d"}>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TAGCRoziKasimaKosokuryoHokokuListGetRes>
                    ) => {
                      let dt = ""
                      if (context.item.積日)
                        dt = dayjs(context.item.積日).format("YYYY/MM/DD")
                      return <>{dt}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClass="read-only-cell"
                  binding="卸日"
                  width={100}
                  header="卸日"
                  format={"d"}>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TAGCRoziKasimaKosokuryoHokokuListGetRes>
                    ) => {
                      let dt = ""
                      if (context.item.卸日)
                        dt = dayjs(context.item.卸日).format("YYYY/MM/DD")
                      return <>{dt}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClass="read-only-cell"
                  isReadOnly={true}
                  binding="請求車番"
                  sortMemberPath={"padding車番"}
                  width={80}
                  header="車番"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClass="read-only-cell"
                  isReadOnly={true}
                  binding="荷主依頼番号"
                  width={110}
                  header="輸送No"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClass="read-only-cell"
                  binding="請求理由"
                  width={400}
                  isReadOnly={true}
                  header="請求理由"></wjrGrid.FlexGridColumn>
                {/* 2023/02/01時点では不要となったため非表示 */}
                {/* 将来的に復活もあり得ることが示唆されているため、項目自体は残す */}
                {/* <wjrGrid.FlexGridColumn
                  binding="高速代請求区間"
                  visible={false}
                  width={400}
                  header="高速代請求区間"></wjrGrid.FlexGridColumn> */}
                <wjrGrid.FlexGridColumn
                  cssClass="read-only-cell"
                  isReadOnly={true}
                  binding="請求高速料税抜"
                  // binding="高速料税抜"
                  width={130}
                  header="高速料（税抜）"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClass="read-only-cell"
                  isReadOnly={true}
                  binding="請求高速料"
                  // binding="高速料税込"
                  width={130}
                  header="高速料（税込）"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default AGCRoziKasimaKosokuryoHokokuRegister
